import React from 'react'

import { Button, ModalBase } from '@components/atoms'
import { trackingAPI } from '@services/TrackingAPI'
import { useAppSelector } from '@store/hooks'

import { styleModalFreeLimit } from '../ModalFreeLimit/styles'

const { Title, Info, ButtonsContainer } = styleModalFreeLimit

export const ModalFreeSevenQuestions = () => {
	const {
		modal: { modalName, modalInfo },
		profile: { id: clientId },
	} = useAppSelector((state) => state)

	const [setTracking] = trackingAPI.useSetTrackingMutation()

	return (
		<ModalBase
			title=''
			open={modalName === 'freeSevenQuestions'}
			variant='freeSevenQuestionsIcon'
		>
			<div>
				{modalInfo?.title && <Title>{modalInfo.title}</Title>}
				{!modalInfo?.noShowInfo && (
					<Info>
						Como recompensa por ter acertado mais de 70% das questões
						respondidas até agora, nós lhe oferecemos uma oferta exclusiva!
					</Info>
				)}
				{modalInfo?.button && (
					<ButtonsContainer>
						<a
							href='https://pay.hotmart.com/T18298676N?off=a35mgbgv&checkoutMode=10'
							target='_blank'
							rel='noopener noreferrer'
							style={{ width: '100%' }}
						>
							<Button
								onClick={() =>
									modalInfo?.button?.action
										? modalInfo?.button?.action()
										: setTracking({
												clientId,
												action: 'freeSevenQuestionsModalCTA',
										  })
								}
								icon={modalInfo?.button?.icon}
								color='orange'
								css={{
									minHeight: '48px',
									textAlign: 'center',
									_font: 'medium',
									fontWeight: 500,
								}}
							>
								{modalInfo.button?.label}
							</Button>
						</a>
					</ButtonsContainer>
				)}
			</div>
		</ModalBase>
	)
}
